import { ChangeDetectionStrategy, Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { DisplayType, SummitIdObject } from '@summit/models';

import { NgTemplateOutlet } from '@angular/common';
import { BlurDirective } from '@summit/ui';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { SummitControl } from '../../models';
import { SFormErrorInputComponent } from '../s-form-error-input';
@Component({
  selector: 's-form-input-text',
  templateUrl: './s-form-input-text.component.html',
  styleUrls: ['./s-form-input-text.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SFormErrorInputComponent,
    BlurDirective,
    FloatLabelModule,
    InputGroupModule,
    InputGroupAddonModule,
    NgTemplateOutlet,
    InputMaskModule,
    InputTextModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SFormInputTextComponent<T extends SummitIdObject> extends SummitControl<T> implements OnInit {
  @Input() type: string | undefined;
  @Input() labelVariant: 'in' | 'on';
  @Input() mask: string | undefined;
  @Input() placeholder: string;
  @Input() size: 'small' | 'normal' | 'large' = 'normal';
  @ContentChild('prefix') prefix: TemplateRef<unknown>;
  @ContentChild('suffix') suffix: TemplateRef<unknown>;
  public hasFocus: boolean;

  override ngOnInit(): void {
    super.ngOnInit();
    this.hasFocus = this.fieldFocus ?? false;
    this.labelVariant = this.labelVariant ?? 'on';

    switch (this.attribute?.displayType) {
      case DisplayType.Number: {
        console.warn(`Display type is Number using form-input-text on ${this.fieldName}`);
        break;
      }
      case DisplayType.Miles: {
        console.warn(`Display type is Miles using form-input-text on ${this.fieldName}`);
        break;
      }
      case DisplayType.Money: {
        console.warn(`Display type is Money using form-input-text on ${this.fieldName}`);
        break;
      }
      case DisplayType.Financial: {
        console.warn(`Display type is Financial using form-input-text on ${this.fieldName}`);
        break;
      }
      case DisplayType.Rate: {
        console.warn(`Display type is Rate using form-input-text on ${this.fieldName}`);
        break;
      }
      default: {
        break;
      }
    }
  }

  public onFocus(_$event: Event) {
    //console.log('onFocus');
    this.hasFocus = true;
  }
  public onBlur(_$event: Event) {
    //console.log('onBlur');
    this.hasFocus = false;
  }
}
